"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.periodFormat = exports.isActiveRoute = exports.humanizeDate = exports.formatNumber = exports.lastSeen = exports.declOfNum = exports.isDefined = exports.isNull = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
const isNull = (value) => {
    return value === null || typeof value == "undefined";
};
exports.isNull = isNull;
const isDefined = (value) => {
    return !(0, exports.isNull)(value);
};
exports.isDefined = isDefined;
const declOfNum = function (number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};
exports.declOfNum = declOfNum;
const lastSeen = (value, decl) => {
    return i18n_1.default.t("ago_V_V", [value, (0, exports.declOfNum)(value, decl)]);
};
exports.lastSeen = lastSeen;
const formatNumber = (num) => {
    let result = num.toString();
    if (!!num && result.match(/(\.0+$)/g)) {
        result = result.replace(/(\.0+$)/g, "");
    }
    return num ? result.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ") : 0;
};
exports.formatNumber = formatNumber;
const humanizeDate = (date, UTC = false) => {
    // UTC: date в зоне UTC в формате без указания зоны
    const dtime = UTC ? dayjs_1.default.utc(date).local() : (0, dayjs_1.default)(date);
    const now = (0, dayjs_1.default)(new Date());
    if (now.year() !== dtime.year()) {
        return dtime.format("DD MMMM HH:mm, YYYY");
    }
    const dayDiff = now.diff(dtime, "day");
    if (dayDiff < 7 && dayDiff > 0) {
        return (0, exports.lastSeen)(dayDiff, i18n_1.default.t("declension").long.d);
    }
    const hourDiff = now.diff(dtime, "hour");
    if (hourDiff < 24 && hourDiff > 0) {
        return (0, exports.lastSeen)(hourDiff, i18n_1.default.t("declension").long.hh);
    }
    const minuteDiff = now.diff(dtime, "minute");
    if (minuteDiff < 60 && minuteDiff > 0) {
        return (0, exports.lastSeen)(minuteDiff, i18n_1.default.t("declension").long.mm_);
    }
    const secondDiff = now.diff(dtime, "second");
    if (secondDiff < 60 && secondDiff > 0) {
        return (0, exports.lastSeen)(secondDiff, i18n_1.default.t("declension").long.ss_);
    }
    return dtime.format("DD MMMM HH:mm");
};
exports.humanizeDate = humanizeDate;
const isActiveRoute = (section, pathValue) => {
    const regexp = new RegExp(`^${section}`, "gmi");
    return regexp.test(pathValue);
};
exports.isActiveRoute = isActiveRoute;
const periodFormat = (from, to, time = false) => {
    if (!from.date() && !to.date())
        return;
    const now = (0, dayjs_1.default)(new Date());
    let format = [];
    let result = "";
    if (from.year() != to.year() || from.year() != now.year() || to.year() != now.year()) {
        if (time) {
            format = ["D MMMM YYYY HH:mm", "HH:mm"];
        }
        else {
            format = ["D MMM YYYY", "D MMM YYYY"];
        }
    }
    else if (from.month() != to.month() || time) {
        if (time) {
            if (from.date() == to.date()) {
                format = ["D MMMM, dd HH:mm", "HH:mm"];
            }
            else {
                format = ["D MMMM, dd HH:mm", "D MMMM, dd HH:mm"];
            }
        }
        else {
            format = ["D MMM", "D MMM"];
        }
    }
    else if (from.date() != to.date()) {
        if (time) {
            format = ["D HH:mm", "D MMMM HH:mm"];
        }
        else {
            format = ["D", "D MMM"];
        }
    }
    else {
        if (time) {
            format = ["D MMMM HH:mm", "HH:mm"];
        }
        else {
            format = ["D MMM"];
        }
    }
    if (format.length > 1) {
        result = from.format(format[0]) + " — " + to.format(format[1]);
    }
    else {
        result = from.format(format[0]);
    }
    return result;
};
exports.periodFormat = periodFormat;
